import { Derivation } from '../interfaces/Derivation';
import { useDerivationActions } from '../hooks/useDerivationActions';
import { SilaButton } from './SilaButton';

interface FinishDerivationButtonProps {
  selectedDerivation: Derivation | null;
  onDeselect: () => void;
}

export const FinishDerivationButton: React.FC<FinishDerivationButtonProps> = ({
  selectedDerivation,
  onDeselect,
}) => {
  const { finishDerivation, isFinishing } = useDerivationActions();

  const handleFinish = async () => {
    if (!selectedDerivation) return;
    try {
      await finishDerivation(selectedDerivation.id);
      onDeselect();
    } catch (err) {
      console.error('Error al finalizar el caso:', err);
    }
  };

  return (
    <SilaButton
      onClick={handleFinish}
      isLoading={isFinishing}
      disabled={!selectedDerivation}
      variant='danger'
      className='w-full'
    >
      Finalizar derivación
    </SilaButton>
  );
};
